import { debounce } from '../utils';

const gridDimensions = ($grid) => {
    const colCount = (
        $grid
            .css('grid-template-columns')
            .split(' ')
            .length
    );
    const rowCount = Math.floor($grid.children().length / colCount);
    return { colCount, rowCount };
};

const position = ($grid, $card) => {
    const { colCount, rowCount } = gridDimensions($grid);
    const index = $card.index();
    return {
        row: Math.floor(index / colCount),
        col: index % colCount,
    };
};

const equalize = () => {
    $('.fluid-grid').each(function() {
        const $grid = $(this);
        const { colCount, rowCount } = gridDimensions($grid);
        $grid.children().css('height', 'auto');
        $grid.children().each(function() {
            const $card = $(this);
            const $grid = $card.parent();
            const $head = $card.find('.card-head');
            const $body = $card.find('.card-body');
            const {row, col} = position($grid, $card);
            $head.height('auto');
            $body.height('auto');
            $card.attr('data-row', row);
            $card.attr('data-col', col);
        });
        for (let i = 0; i < rowCount; i++) {
            const $cards = $grid.find(`[data-row="${i}"]`);
            const $heads = $cards.find('.card-head');
            const $bodies = $cards.find('.card-body');
            const headHeights = (
                $heads
                    .map((index, el) => $(el).height())
                    .get()
            );
            $heads.height(Math.max(...headHeights));
            const bodyHeights = (
                $bodies
                    .map((index, el) => $(el).height())
                    .get()
            );
            $bodies.height(Math.max(...bodyHeights));
        }
    });
};

const initialize = () => {
    equalize();
    $(window).resize(
        debounce(
            () => equalize(),
            50
        )
    );
};

export default {
    initialize,
    equalize,
};

